// extracted by mini-css-extract-plugin
module.exports = {"container":"ForInvestors_container__2W815","text":"ForInvestors_text__37yK8"};